function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
}
const handleQuickView = () => {
  document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
};
const debounceQuickView = debounce(handleQuickView, 1000);
document.addEventListener("DOMContentLoaded", (event) => {
  if (BSS_B2B) {
    const targetNode = document.querySelector(".quick-product--wrap");
    const config = { attributes: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          mutation.target.className.includes("is-visible")
        ) {
          debounceQuickView();
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
});
